import React from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs';
import {FaFacebookF} from 'react-icons/fa';
import {TiSocialLinkedin,TiSocialGithub} from 'react-icons/ti'

const SocialMedia = () => {
  return (
    <div className='app__social'>
          <div>
              <a href="https://www.linkedin.com/in/engr-mirza-hamza-umer-3b596617a/">
              <TiSocialLinkedin/>
              </a>
          </div>
          <div>
              <a href="https://twitter.com/MirzaHamzaUmer7">
              <BsTwitter/>
              </a>
          </div>
          <div>
              <a href="https://www.facebook.com/Mirza.Hamza.Umer">
              <FaFacebookF/>
              </a>
          </div>
          <div>
              <a href="https://www.instagram.com/mirhamzaumer786/">
              <BsInstagram/>
              </a>
          </div>
          <div>
              <a href="https://github.com/HamzaUmer">
              <TiSocialGithub/>
              </a>
          </div>
    </div>
  )
}

export default SocialMedia